import { useCallback, useEffect } from 'react';

var useOutsideClick = function useOutsideClick(options) {
  var elements = options.elements,
    callback = options.callback,
    active = options.active;
  var handlePress = useCallback(function (e) {
    var allElements = Array.isArray(elements) ? elements : [elements];
    var clickedInside = allElements.find(function (ref) {
      var _a;
      if (e.target instanceof Node && !((_a = ref.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
        return false;
      }
      return true;
    });
    if (!clickedInside && active) {
      callback();
    }
  }, [active, callback, elements]);
  useEffect(function () {
    window.addEventListener('pointerdown', handlePress);
    return function () {
      window.removeEventListener('pointerdown', handlePress);
    };
  }, [handlePress]);
};

export { useOutsideClick };
